import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import {useId} from "react";

import {OptionItem, SingleSelect} from "@khanacademy/wonder-blocks-dropdown";

import {type ToolRequestedInput} from "../types.ts";

import {RequestedInputLabel} from "./requested-input-label.tsx";

interface Props {
    label: string;
    value: string;
    onChange: (newValue: string) => void;
    options: ToolRequestedInput["selectOptions"];
    description?: string;
    disabled?: boolean;
    required?: boolean;
    values: Record<string, string>;
    error?: string | null;
}

export const RequestedInputSingleSelect = ({
    label,
    value,
    onChange,
    description,
    disabled,
    required,
    options = [],
    values,
    error,
}: Props) => {
    const id = useId();

    const currentOptions =
        typeof options === "function" ? options(values) : options;

    return (
        <RequestedInputLabel
            id={id}
            label={label}
            description={description}
            required={required}
            error={error}
        >
            <SingleSelect
                id={id}
                selectedValue={value}
                onChange={onChange}
                placeholder={t`Select one...`}
                disabled={disabled}
                aria-required={required}
                aria-details={description}
                style={styles.select}
            >
                {currentOptions.map((o, i) => (
                    <OptionItem value={o.value} label={o.label()} key={i} />
                ))}
            </SingleSelect>
        </RequestedInputLabel>
    );
};

const styles = StyleSheet.create({
    select: {
        width: "100%",
    },
});
